import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { NewImplementTemplate, ImplementComponentType, ImplementTemplate } from '../entities/implement-template.model';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class ImplementTemplateService {
    public RequestResult: boolean = true;
    private ErrorResponse: any;

    constructor(private _http: Http, private _snackBar: MatSnackBar) {
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json());
    }

    /**
        Creates a new implement template and maps the given component types to that template.
        Also creates any new component types given that don't yet exist.

        To specify that a component type is new, give it an id of 0. 
    */
    public createNewImplementTemplate(newTemplate: NewImplementTemplate): Observable<string> {
        return this._http.post("api/template/new", newTemplate).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
    }

    /**
     * Gets a list of templates which are global and also ones which belong to customers
     * the user has access to.
     */
    public getTemplateListForUser(): Observable<ImplementTemplate[]> {
        return this._http.get("api/template").share().map(
            (response: Response) => <ImplementTemplate[]>response.json()).catch(this.handleError);
    }

    //public getSchematicImageById(schematicId: number): Observable<string> {
    //    return "";
    //}

    public getTemplateDetails(templateId: number): Observable<NewImplementTemplate> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('templateId', templateId.toString());
        return this._http.get('Api/template/ReturnTemplateById', { search: params }).share().map(
            (response: Response) => <NewImplementTemplate>response.json()).catch(this.handleError);
    }

    // Update an existing implement template.
    public updateExistingImplementTemplate(existingTemplate: NewImplementTemplate): Observable<string> {
        return this._http.post("api/template/update", existingTemplate).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
    }
}